// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionSteps_KvResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/production_steps/kv
 *
 * Returns the production-step catalog projected into a flat list of
 * `{ value, label }` select-options. Wire shape:
 * `dados: ProductionSteps_KvOptionRow[]`.
 *
 * @see ProductionSteps_KvOptionRow
 */
import type { ProductionSteps_KvOptionRow } from './ProductionSteps_KvOptionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductionSteps_KvResponseDados = ProductionSteps_KvOptionRow[];

export type ProductionSteps_KvResponse = ApiResponse<ProductionSteps_KvResponseDados>;

registerResponseContract('ProductionSteps_KvResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      value: { type: 'number',  required: true },
      label: { type: 'string',  required: true },
    },
  },
})
